import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AnimationItem } from 'lottie-web';
import { BMEnterFrameEvent } from 'ngx-lottie';

@Component({
  selector: 'app-mobile-app-payment-completed',
  templateUrl: './mobile-app-payment-completed.component.html',
  styleUrls: ['./mobile-app-payment-completed.component.scss'],
})
export class MobileAppPaymentCompletedComponent  implements OnInit {
  message = 'Your payment information has been saved.';
  private animationItem: AnimationItem;

  constructor(
    private router: ActivatedRoute,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.router.queryParamMap.subscribe(map => {
      if (map.has('message')) {
        const message = map.get('message');
        if (message) {
          this.message = map.get('message');
        }
      }
    });
  }

  animationCreated(animationItem: AnimationItem): void {
    // console.log(animationItem);
    this.animationItem = animationItem;
  }

  onEnterFrame(enterFrameEvent: BMEnterFrameEvent) {
    if (this.animationItem
        && enterFrameEvent.currentTime < enterFrameEvent.totalTime
        && enterFrameEvent.currentTime > enterFrameEvent.totalTime - 1) {
      //pause on last frame
      this.pause();
    }
  }

  private pause() {
    this.ngZone.runOutsideAngular(() => {
      this.animationItem.pause();
    });
  }

}
